<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="name"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('name')">
                            <b-form-input
                                v-model="form.name"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="surname"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('surname')">
                            <b-form-input
                                v-model="form.surname"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="gender"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('gender')">
                            <GenderSelectbox v-model="form.gender" :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="birthdate"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('birthdate')">
                            <select-date v-model="form.birthdate" :validation-error="errors[0]" :state="errors[0] ? false : null" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">

                    <ValidationProvider
                        name="national_id"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('national_id')">
                            <b-form-input
                                v-mask="'###########'"
                                key="national_id"
                                v-model="form.national_id"
                                :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="blood_group"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('blood_group')">
                            <ParameterSelectbox code="blood_group_types"   v-model="form.blood_group" :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="disability_information"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('disability_information')">
                            <b-form-textarea v-model="form.disability_information" no-resize rows="4"></b-form-textarea>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="illness_information"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('illness_information')">
                            <b-form-textarea v-model="form.illness_information" no-resize rows="4"></b-form-textarea>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="allergy_information"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('allergy_information')">
                            <b-form-textarea v-model="form.allergy_information" no-resize rows="4"></b-form-textarea>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="medications_used"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('medications_used')">

                            <b-form-textarea v-model="form.medications_used" no-resize rows="4"></b-form-textarea>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>

                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="habits"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('habits')">
                            <b-form-textarea v-model="form.habits" no-resize rows="4"></b-form-textarea>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="explanation"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('explanation')">
                            <b-form-textarea v-model="form.explanation" no-resize rows="4"></b-form-textarea>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider name="unit" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('unit')">
                            <ParameterSelectbox code="infirmary_guest_units" v-model="form.unit" :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="col-12 mt-3 d-flex">
                <ProcessingButton
                    :disabled="formLoading"
                    :processing="formLoading"
                    @click="save"
                    :text="$t('save').toLocaleUpperCase('tr-TR')"
                />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
//Component
//Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
//Service
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import InfirmaryServices from "@/services/InfirmaryServices";

export default {
    components: {
        ProcessingButton,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            formLoading: false,
            form: {

            }
        }
    },
    methods: {
        async save(){
            const isValid =await this.$refs.formModalValidate.validate()
            if (!isValid) return
            try {
                this.formLoading=true
                const res = await InfirmaryServices.storeGuest(this.form)
                this.$toast.success(this.$t('proccess_success'))
                this.$emit('closeInfirmaryModal',true)
            }catch (err){
                this.showErrors(err,this.$refs.formModalValidate)
            }finally {
                this.formLoading=false
            }

        }

    }
}
</script>
